import React from "react";
import styled from "styled-components";
import { Option } from "../../../shared/interface";
import { theme } from "../../../theme";
import CategoryButton from "../../atoms/CategoryButton";

interface Props {
  categoryArray: Option[];
  nowCategory?: number;
  setCategory?: (e: number) => void;
}
const CategoryFilter: React.FC<Props> = ({
  categoryArray,
  nowCategory,
  setCategory,
}) => {
  return (
    <FilterWrapper>
      {categoryArray.map((val) => (
        <CategoryButton
          key={val.value}
          onClick={() => {
            if (setCategory) setCategory(val.value);
          }}
          isSelected={nowCategory === val.value}
        >
          {val.label}
        </CategoryButton>
      ))}
    </FilterWrapper>
  );
};
export default CategoryFilter;

const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${theme.colors.gray6};
  justify-content: flex-start;
  max-height: 65px;
  padding: 0px 8px;
`;
